(() => {
  'use strict';

  const ROOT_SELECTOR = '[data-mmg-customer-intelligence="v1"]';
  const INPUT_EVENT = 'mmg:kairos-session:shadow-context';
  const STORAGE_KEY = 'mmg.kairos-conductor-shadow.v1';
  const EVENT_NAME = 'mmg:kairos-conductor:shadow';
  const CONTRACT_VERSION = '1.0';

  function cleanString(value) {
    return typeof value === 'string' && value.trim().length ? value.trim() : null;
  }

  function cleanEligibleResourceIDs(value) {
    if (!Array.isArray(value)) return [];
    return [...new Set(value.filter((item) => typeof item === 'string' && item.trim().length).map((item) => item.trim()))];
  }

  function buildEvidence(context) {
    const eligibleResourceIDs = cleanEligibleResourceIDs(context?.eligibleResourceIDs);
    const errors = [];

    if (!context || typeof context !== 'object') errors.push('SERVER_SHADOW_CONTEXT_UNAVAILABLE');
    if (context?.serverValidated !== true) errors.push('SERVER_VALIDATION_REQUIRED');
    if (context?.mode !== 'SHADOW') errors.push('SHADOW_MODE_REQUIRED');
    if (context?.customerVisible !== false) errors.push('CUSTOMER_VISIBLE_OUTPUT_FORBIDDEN');
    if (!cleanString(context?.graphVersion)) errors.push('GRAPH_VERSION_REQUIRED');
    if (!cleanString(context?.provenanceVersion)) errors.push('PROVENANCE_VERSION_REQUIRED');
    if (context?.sessionActive !== true) errors.push('SERVER_SESSION_REQUIRED');
    if (context?.conductorReady === true && eligibleResourceIDs.length === 0) errors.push('ELIGIBLE_RESOURCE_SET_UNAVAILABLE');
    if (context?.conductorReady !== true) errors.push('SERVER_CONDUCTOR_VALIDATION_REQUIRED');

    return {
      contractVersion: CONTRACT_VERSION,
      mode: 'SHADOW',
      graphVersion: cleanString(context?.graphVersion),
      provenanceVersion: cleanString(context?.provenanceVersion),
      sessionActive: context?.sessionActive === true,
      eligibleResourceIDs,
      eligibleResourceCount: eligibleResourceIDs.length,
      serverValidated: context?.serverValidated === true,
      conductorReady: context?.conductorReady === true,
      fallbackRequired: context?.fallbackRequired !== false,
      reason: cleanString(context?.reason),
      readyForConductorPlan: errors.length === 0,
      validationErrors: [...new Set(errors)],
      customerVisible: false,
      externalProviderUsed: false,
      presentationApplied: false,
    };
  }

  function publishEvidence(context) {
    const evidence = buildEvidence(context);
    window.MMGKairosConductorShadowEvidence = evidence;
    try {
      window.sessionStorage.setItem(STORAGE_KEY, JSON.stringify(evidence));
    } catch (_) {
      // Session storage is optional evidence persistence only.
    }
    window.dispatchEvent(new CustomEvent(EVENT_NAME, { detail: evidence }));
    return evidence;
  }

  function boot() {
    const root = document.querySelector(ROOT_SELECTOR);
    if (!root || root.dataset.mmgKairosConductorShadowEnabled !== 'true') return;

    window.addEventListener(INPUT_EVENT, (event) => {
      publishEvidence(event?.detail ?? null);
    });

    if (window.MMGKairosSessionShadowContext) {
      publishEvidence(window.MMGKairosSessionShadowContext);
      return;
    }

    publishEvidence(null);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
})();